import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemHeading,
} from 'react-accessible-accordion';

// import { Container } from './styles';

export default function Faq() {
  return (
    <Accordion>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>O que é a Apollo Partners?</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            A Apollo Partners é uma empresa de profissionais de tecnologia, que
            resolvem problemas reais das empresas. Temos parceria com empresaas
            de diversos tamanhos e segmentos, no qual entregamos uma soluçāo
            para o problema de tecnologia deles, desde trabalho em projetos
            pontuais, trabalhos contínuos remotos e até alocando um Apollo
            Partner dentro dos nossos clientes.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            Para quem é a Apollo Partners?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            A Apollo Partners sāo para profissionais de tecnologia que entendem
            de problemas de negócios reais, que tem consciência que a ferramenta
            utilizada em um projeto nāo tem mais importância do que o problema
            que será resolvido. Na nossa equipe temos pessoas de diferentes
            conhecimentos: engenheiro de softwares (backend, frontend, mobile),
            analista de dados, cientista de dados, web designers, engenheiros de
            banco de dados. Se torne um Apollo Partners também!
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Como funciona a Apollo Partners?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            A Apollo Partners possui clientes de diversos segmentos e tamanho,
            dentro e fora do Brasil, que precisam de soluções de tecnologia.
            Desde criaçāo de aplicações web até criaçāo de projetos mais
            complexos. E os Apollo Partners têm acesso a todas as vagas em
            aberto dos nosso clientes, e podem se candidatar para essas vagas,
            ou você pode ser recrutado para a vaga. Nós nāo somos uma empresa de
            recrutamento que indica profissionais para a empresa, somos uma
            empresa de profissionais de tecnologia que aloca os Apollo Partners
            em vagas em aberto de nossos clientes.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Como se tornar um Apollo Partner?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Se cadastre na plataforma da Apollo
            (platform.apollopartners.com.br), e comece a realizar os desafios da
            plataforma. Dessa forma você irá aumentar o seu Nível Apollo dentro
            da plataforma e poderá se candidatar nas vagas que temos em aberto.
            Ao se candidatar para uma das vagas, você poderá ir para a fase de
            conversas e se for aprovado, você começa a trabalhar imediatamente,
            se tornando um Apollo Partners.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton> O que sāo os Desafios?</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Os Desafios sāo exercícios práticos e teóricos de diversas áreas que
            sāo disponíveis nos Módulos de Tecnologia, Negócios e Mentalidade
            Apollo, você poderá realizar os desafios dos Módulos, a Apollo irá
            avaliar todos os desafios, e se estiver errado, você poderá refazer
            o desafio, para conseguir seu certificado do Módulo do desafio. Ter
            certificados dos Módulos faz com que você aumente de Nívelo Apollo e
            tenha mais chance de trabalhar na vaga que voce quiser.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton> O que é a Tutoria Apollo?</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Na Apollo acreditamos que o conhecimento precisa ser compartilhado,
            pois assim os resultados sāo otimizados. E a Tutoria Apollo tem esse
            objetivo, dividir o conhecimento que você já sabe, e receber o
            conhecimento que você ainda nāo tem. Incentivamos à todas as pessoas
            serem Tutor ou Aluno da Tutoria, pois sabemos que quando temos
            alguém com mais conhecimento que a gente, nós aprendemos mais
            rápido. E quando ensinamos alguém fixamos o conhecimento.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Quais sāo as vagas disponívenis na Plataforma Apollo Empresas?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            As vagas disponíveis sāo de todos os nossos clientes que possuem a
            necessidade de um profissional de tecnologia. As vagas sāo bem
            diversificadas, com diferentes níveis de conhecimento (Básico ao
            Master), com necessidades de negócios diferentes, remoto ou
            presencial, e diferentes habilidades.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Como eu me candidato para uma vaga?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Veja as vagas disponíveis na nossa plataforma, leia o resumo da vaga
            e os requisitos desejado para a vaga. Os requisitos sāo Nível
            Apollo, Certificado de Negócios e Certificado de Tecnologia. Todos
            os requisitos necessários estāo disponíveis na própria plataforma,
            sendo extremamente viável você se qualificiar para a vaga, e ter
            grandes chances de trabalhar na vaga que você quiser.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Preciso fazer todas os desafios da Plataforma Apollo Empresas?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Sim, aconselhamos fortemente, pois dessa forma você conseguirá os
            certificados dos Módulos de Tecnologia e Negócios, além de aumentar
            seu Nível Apollo.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            Quais as minhas chances de ser alocado em uma das vagas?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Tendo os requisitos desejados para a vaga completos, você será
            convidado pra agendar uma ou mais conversar para conhecermos melhor
            você e tirarmos suas dúvidas sobre a vaga. Se a nossa conversa for
            boa para você e para a gente, você inicia na vaga de trabalho
            imediatamente. Simples e objetivo assim!
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>O que sāo os Níveis Apollo?</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Os Níveis Apollo sāo medalhas que você tem para ser conquistadas e
            facilitar você conseguir a vaga de trabalho que quiser. Sāo cinco
            níveis: iniciante, básico, intermediário, avançado e master, no qual
            cada uma delas possui critérios como: desafios validados,
            certificado de projetos, certificado Mentalidade Apollo, período de
            tutoria e trabalhos realizados na Apollo Jr.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {' '}
            Nāo tenho nenhum conhecimento prévio em programaçāo, o que eu faço?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Você é muito bem vindo na Apollo Partners, sugerimos você navegar
            pela plataforma, visitando os Desafios, as Vagas Disponíveis e
            solicitar um tutor na página de Tutoria. Com a Tutoria você terá um
            conhecimento profundo, em pouco tempo e conseguirá traçar um plano
            de açāo do que precisa ser feito para você se tornar um Apollo
            Partner.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            Tenho muito conhecimento em desenvolvimento, preciso fazer os
            desafios?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Sim, por mais que você tenha um profundo conhecimento, precisamos
            saber disso através dos nossos desafios. Sugerimos você pular os
            níveis Iniciante e Básico, e já iniciar nos desafios Intermediário,
            Avançado ou até Master.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            Qual o meu vínculo empregáticio com a Apollo Partners?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            O vínculo empregáticio inicial de prestador de serviço, com um plano
            de carreira claro para você se tornar sócio da Apollo Partners.
          </p>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
}
